import MultiSelect from './MultiSelect';
export default MultiSelect;
//# sourceMappingURL=index.js.map